import React from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import LabelCustomSmall from '../../../../label-custom-small'
import Highway from './../../../../../images/Highway.svg'
import { Image } from 'react-bootstrap'

export default function EmpWelfareBEM() {
  return (
    <>
      <Card.Body className="overflow-auto">
        <BtnBack text={'สิทธิค่าทางด่วน'} className={''} />

        <Row className="mt-3">
          <Col xl={4}>
            <div
              className="p-3 rounded-3 "
              style={{ backgroundColor: '#EEF4FF', height: '100%' }}
            >
              <div
                className="rounded-3"
                style={{ height: '10rem', backgroundColor: '#ced4da' }}
              ></div>
              <Form.Group className="mt-3">
                <LabelCustomSmall>Card ID</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3">
                <LabelCustomSmall>ผู้ถือบัตร</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3">
                <LabelCustomSmall>วันออกบัตร</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3">
                <LabelCustomSmall>วันหมดอายุ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
            </div>
          </Col>
          <Col xl={8}>
            <div className="d-flex">
              <div className="me-3">
                <Image
                  src={Highway}
                  style={{ height: '45px', width: '45px' }}
                />
              </div>{' '}
              <span className="my-auto">มีสิทธิ 500 บาทต่อเดือน</span>
            </div>
            <Row>
              <Form.Group className="mt-3 col-xl-4">
                <LabelCustomSmall>วงเงินในบัตร ณ วันที่ 1</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-4">
                <LabelCustomSmall>
                  เงินคงเหลือ ณ วันสุดท้ายของเดือน
                </LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-4">
                <LabelCustomSmall>ยอดที่ใช้จริงของเดือน</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-4">
                <LabelCustomSmall>
                  ยอดที่หักส่วนเกินจากพนักงานผ่านเงินเดือน
                </LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  )
}
